module.exports = __webpack_public_path__ + "img/chelmsford.73d8ff16.jpg";